import { Button, Modal, Typography } from "../common";

export const LinkedInShareModal = ({
  showLinkedInModal,
  setShowLinkedInModal,
  pendingLinkedInUrl,
}: {
  showLinkedInModal: boolean;
  setShowLinkedInModal: (show: boolean) => void;
  pendingLinkedInUrl: string;
}) => {
  return (
    <Modal
      activeModal={showLinkedInModal}
      bodyClass="max-w-[500px]"
      dialogClass="z-[1500]"
      onClose={() => setShowLinkedInModal(false)}
      title={
        <span>
          <span role="img" aria-label="LinkedIn">
            🔗
          </span>{" "}
          Showcase Your Certificate!
        </span>
      }
      centered
      footerContent={
        <Button
          variant="filled"
          size="large"
          className="w-full !bg-[#0077b5] !hover:bg-[#005983] text-white font-semibold rounded-full text-base py-3 px-6"
          onClick={() => {
            setShowLinkedInModal(false);
            window.open(pendingLinkedInUrl, "_blank");
          }}
        >
          Continue to LinkedIn
        </Button>
      }
    >
      <div className="text-left px-4 py-2">
        <Typography variant="p" className="mb-4 !text-sm">
          Your certificate image has been downloaded and the caption is copied
          to your clipboard.Paste the caption and attach your certificate image
          in your post to showcase your achievement!
        </Typography>
      </div>
    </Modal>
  );
};
